import ScreenSizeEditScreen from './ScreenSizeEditScreen';

export default ScreenSizeEditScreen;
